import { render, staticRenderFns } from "./StudentsMain.vue?vue&type=template&id=558cc186&"
import script from "./StudentsMain.vue?vue&type=script&lang=js&"
export * from "./StudentsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports